'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import image from '../../../../img/swift-logo.png';
import {Button} from '../../../components/buttons/Button';
import {I18nMessage} from '../../../components/I18nMessage';

export function LoginView(props) {
  return (
    <div className={classNames("Login", props.className)}>
      <div className="Login__content">
        <div className="Login__banner">
          <img src={image} />
        </div>
        <div className="Login__buttonArea">
          <Button
            className="Login__button"
            label={<I18nMessage message="onboarding.welcome.login" />}
            onClick={props.onShowLogin}
          />
        </div>
      </div>
    </div>
  );
}

LoginView.propTypes = {
  className: T.string,
  onShowLogin: T.func,
};

LoginView.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/js/auth/components/Login/LoginView.js